import { get } from "lodash";

export const getUserCargando = (state) => get(state, "usuario.cargando");
export const getUserError = (state) => get(state, "usuario.error");
export const getUser = (state) => get(state, "usuario");
export const isAuth = (state) => get(state, "usuario.isLogged");

export const getNotificaciones = (state) =>
  get(state, "notificaciones.listado");
export const getPublicaciones = (state) =>
  get(state, "notificaciones.publicaciones");
export const getCargando = (state) => get(state, "notificaciones.loading");
export const getGrupos = (state) => get(state, "notificaciones.grupos");

export const getMensaje = (state) => get(state, "mensajes");

export const getLdD = (state) => get(state, "lista.listado");
export const getLdDFecha = (state) => get(state, "lista.fecha");

export const getDiasJefe = (state) => get(state, "diasjefe.listado");

export const getDias = (state) => get(state, "dias.listado");

export const getAnticipos = (state) => get(state, "anticipos.listado");

export const getElementos = (state) => get(state, "elementos.listado");
export const getGruposElementos = (state) => get(state, "elementos.elementos");
export const getNtf = (state) => get(state, "notificaciones.ntf");

export const getEquipos = (state) => get(state, "equipos.listado");

export const getVehiculoCargando = (state) => get(state, "vehiculo.cargando");
export const getPoolVehiculos = (state) => get(state, "vehiculo.pool");
export const getVehiculos = (state) => get(state, "vehiculo.propios");
export const getVehiculoPropiedades = (state) =>
  get(state, "vehiculo.propiedades");
export const getVehiculoSeleccionado = (state) => get(state, "vehiculo.movil");
export const getOpcionesPropiedades = (state) =>
  get(state, "vehiculo.opciones");
